import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';
import { ACTION_LOGS_BEGIN_DATE } from '../../../utils/dateUtils';

interface ActionLogsDateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onApply: () => void;
}

const ActionLogsDateRangePicker: React.FC<ActionLogsDateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
      >
        <DateTimePicker
          label="Start datetime"
          value={startDate}
          onChange={onStartDateChange}
          minDate={ACTION_LOGS_BEGIN_DATE}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150 },
            },
          }}
        />
        <DateTimePicker
          label="End datetime"
          value={endDate}
          onChange={onEndDateChange}
          minDate={ACTION_LOGS_BEGIN_DATE}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              size: 'small',
              sx: { minWidth: 150 },
            },
          }}
        />
        <Button
          variant="contained"
          sx={{ height: 40, width: { xs: '100%', sm: 'auto' } }}
          onClick={onApply}
        >
          Apply
        </Button>
      </Stack>
    </LocalizationProvider>
  );
};

export default ActionLogsDateRangePicker;
